export function jqBanaScroll() {

    //btmBana
    function toggleHeaderBtnWrap() {
      const windowWidth = $(window).width();
      if (windowWidth <= 767) {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const documentHeight = $(document).height();
    
        const btmBanaHeight = $('#btmBana').outerHeight() || 0;
        const footerHeight = $('footer').outerHeight() || 0;
        const thresholdBottom = documentHeight - (btmBanaHeight + footerHeight);
    
        const pIndexHeroHeight = $('.p-indexHero').outerHeight() || 0;
        const pIvHeroHeight = $('.c-pageHero').outerHeight() || 0;
        const pInterviewHeroHeight = $('.p-interviewHero').outerHeight() || 0;
        const pDetailHeroHeight = $('.p-detailHero').outerHeight() || 0;
        const heroThreshold = Math.max(pIndexHeroHeight, pIvHeroHeight, pInterviewHeroHeight, pDetailHeroHeight);
    
        const scrollBottomPos = scrollTop + windowHeight;
    
        const $headerBtnWrap = $('.l-header_btnWrap');
    
        if (scrollBottomPos < thresholdBottom && scrollTop >= heroThreshold) {
          if (!$headerBtnWrap.hasClass('is-active')) {
            $headerBtnWrap.addClass('is-active').fadeIn();
          }
        } else {
          $headerBtnWrap.removeClass('is-active').fadeOut();
        }
      } else {
        // 768px以上はクラスを外し、非表示に
        $('.l-header_btnWrap').removeClass('is-active');
      }
    }
    
    $(window).on('scroll resize', toggleHeaderBtnWrap);
    $(document).ready(toggleHeaderBtnWrap);

}
